module.exports = __webpack_public_path__ + "static/media/history-buddha.7ad8ac06.vtt";